<template>
    <v-card elevation="0" outlined>
            <v-data-table
                    style="width: 100%;"
                    fixed-header
                    :items="inboxes"
                    :sort-by="['date']"
                    :sort-desc="[true]"
                    :headers="headers"
                    hide-default-footer
                    disable-pagination>

                <template v-slot:item.date="{ item }">
                    <v-card-text>{{ item.date | formatDate }}</v-card-text>
                </template>

                <template v-slot:item.uid="{ item }">
                    <v-card-text>{{ getUserName(item) }}</v-card-text>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="!ifCanDeleteInboxMessage()"
                                    :loading="false"
                                   icon
                                   color="red"
                                   v-bind="attrs"
                                   v-on="on"
                                   class="mr-1"
                                   @click="onPressDelete(item)">
                                <v-icon size="22">mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Delete from inbox</span>
                    </v-tooltip>
                </template>
            </v-data-table>
    </v-card>
</template>

<script>

import {InboxStoreUtils} from "@/modules/minbox/database/InboxStoreUtils";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";

export default {
    name: "i-view",
    components: {},
    data: () => ({
        headers: [
            {text: 'Name', sortable: true, value: 'name', class: "white blue--text", color: "red"},
            {text: 'Uid', sortable: true, value: 'uid', class: "white blue--text", color: "red"},
            {text: 'Created', sortable: true, value: 'date', class: "white blue--text", color: "red"},
            {text: 'Os', sortable: true, value: 'os', class: "white blue--text", color: "red"},
            {text: 'Version', sortable: true, value: 'version', class: "white blue--text", color: "red"},
            {text: 'Actions', sortable: false, value: 'actions', width: '80px', class: "white blue--text"}
        ],
    }),
    methods:{
        getMyUserUid(){
            return PermissionsStoreUtils.getMyUserUid();
        },
        ifCanDeleteInboxMessage(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.INBOX_TAB.subpermissions.INBOX_TAB_DELETE.id)
        },
        getUserName(user){
            return PermissionsStoreUtils.getUserName(user.uid)
        },
        onPressDelete(item){
            this.$confirm("Are you sure?").then(() => {
                InboxStoreUtils.deleteInbox(item.key)
                    .then(() => {
                        this.loading = null
                        this.$notify({title: 'Inbox successfully deleted!', text: "", type: "succes"});
                    })
                    .catch((error) => {
                        this.loading = null
                        this.$notify({title: 'Inbox delete failed!', text: error, type: "error"});
                    })
            })
        }
    },
    computed: {
        inboxes() {
            return InboxStoreUtils.getInboxes()
        }
    }
}
</script>

<style scoped>
</style>